import { Features } from 'syft-acp-core/components/FeatureFlaggingProvider'

export type OneHostFlagConfig = {
  flag: keyof Features
  pathname?: string
}

export type OneHostRouteRedirect = {
  redirect: boolean
  pathname?: string
}

export type PathConfig = OneHostFlagConfig | OneHostRouteRedirect

type OneHostRouteConfig = {
  [path: string]: PathConfig
}

export const oneHostRoutes: OneHostRouteConfig = {
  '/agencies/role-compliance': {
    redirect: true,
  },
  '/conduct/appeals/list': {
    flag: 'onehost_acp_nav_conduct_toggle',
  },
  '/conduct/ban-reviews/list': {
    flag: 'onehost_acp_nav_conduct_toggle',
  },
  '/finance/holiday-pay': {
    redirect: true,
  },
  '/entity/workers/view/:id/compliance': {
    redirect: true,
  },
  '/shifts/all-shifts': {
    flag: 'onehost_acp_all_shift',
  },
  '/entity/employers/view/:employerId/bulk-po-numbers': {
    flag: 'acp_bulk_update_po_numbers',
  },
  '/finance/rate-cards/agency': {
    redirect: true,
  },
  '/finance/rate-cards/agency/:rest+': {
    redirect: true,
  },
  '/finance/insurance-class-codes': {
    redirect: true,
  },
  '/finance/bank-holidays': {
    redirect: true,
  },
  '/finance/payroll': {
    redirect: true,
  },
  '/finance/upcoming-pay': {
    redirect: true,
  },
  '/finance/rate-corrections': {
    redirect: true,
  },
  '/entity/workers/view/:id/interviews/list': {
    redirect: true,
  },
  '/entity/workers/interviews': {
    redirect: true,
  },
  '/entity/workers/interviews/:id': {
    redirect: true,
  },
  '/entity/workers/view/:id/duplicate-accounts/list': {
    redirect: true,
  },
  '/entity/workers/view/:id/notes': {
    redirect: true,
  },
  '/watchlist/compliance': {
    flag: 'onehost_acp_watchlist_compliance',
  },
  '/watchlist/documents': {
    redirect: true,
  },
  '/agencies/onboarding': {
    redirect: true,
  },
  '/agencies/invited': {
    redirect: true,
  },
  '/agencies/disabled': {
    redirect: true,
  },
}
